<template>
	<div class="modify-price">
		<el-dialog
			title="修改价格"
			top="4vh"
			width="1200px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:visible.sync="dialogVisible"
			@close="closeDialog"
		>
			<el-row type="flex" justify="end">
				<el-button
					type="success"
					@click="handleUpload"
					:loading="loadingUpload"
					>上 传</el-button
				>
			</el-row>
			<el-tabs v-model="tabName" @tab-click="handleTabClick">
				<template v-for="item in listTabs">
					<el-tab-pane
						:label="item.cusSku"
						:name="item.cusSku"
						:key="item.id"
					>
						<el-form class="custom-form" inline>
							<el-row type="flex" justify="space-between">
								<el-form-item label="价格">
									<el-input
										type="text"
										placeholder="请输入"
										v-model="formData.productPrice"
									></el-input>
								</el-form-item>
								<el-form-item label="促销价格">
									<el-input
										type="text"
										placeholder="请输入"
										v-model="formData.sale"
									></el-input>
								</el-form-item>
								<el-form-item label="促销时间">
									<el-date-picker
										v-model="formData.saleTime"
										unlink-panels
										size="small"
										type="datetimerange"
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期"
										format="yyyy-MM-dd HH:mm:ss"
										value-format="yyyy-MM-dd HH:mm:ss"
									>
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button
										type="primary"
										@click="setTableVal"
										>设置</el-button
									>
								</el-form-item>
							</el-row>
						</el-form>
						<el-table
							ref="multipleTable"
							:data="[item]"
							border
							lazy
							:load="tableLoad"
							row-key="id"
							:tree-props="{
								children: 'children',
								hasChildren: 'variantCount',
							}"
						>
							<el-table-column
								align="center"
								width="50"
							></el-table-column>
							<el-table-column
								prop="cusSku"
								label="SKU"
								align="center"
								width="300"
							></el-table-column>
							<el-table-column
								:label="`价格/${countryCurrency}`"
								align="center"
							>
								<template slot-scope="scope">
									<el-input
										v-model="scope.row.cusProductPrice"
									></el-input>
								</template>
							</el-table-column>
							<el-table-column
								:label="`促销价格/${countryCurrency}`"
								align="center"
							>
								<template slot-scope="scope">
									<el-input
										v-model="scope.row.sale"
									></el-input>
								</template>
							</el-table-column>
							<el-table-column
								label="促销时间"
								align="center"
								width="430"
							>
								<template slot-scope="scope">
									<el-date-picker
										unlink-panels
										size="small"
										type="datetimerange"
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期"
										v-model="scope.row.saleTime"
										format="yyyy-MM-dd HH:mm:ss"
										value-format="yyyy-MM-dd HH:mm:ss"
									>
									</el-date-picker>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</template>
			</el-tabs>
			<div slot="footer">
				<el-button
					type="primary"
					@click="submitUpdate"
					:loading="loadingUpdate"
					>更 新</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
const variantMaps = new Map()

export default {
	name: 'ModifyPrice',
	data() {
		return {
			dialogVisible: false,
			tabName: '',
			listTabs: [],
			shopItem: null,
			countryCurrency: '',
			formData: {
				productPrice: '',
				sale: '',
				saleTime: null,
			},
			loadingUpdate: false,
			loadingUpload: false,
		}
	},
	methods: {
		openDialog(list, shopItem) {
			this.shopItem = shopItem
			this.listTabs = JSON.parse(JSON.stringify(list))
			this.tabName = list[0].cusSku
			this.countryCurrency = list[0].priceCurrency
			this.handleTabClick()
			this.refreshTableLoad()
			this.dialogVisible = true
			this.isUpdate = false
		},
		closeDialog() {
			if (this.isUpdate) {
				this.$emit('close')
			}
		},
		handleTabClick() {
			this.tabIndex = this.listTabs.findIndex(
				(item) => item.cusSku === this.tabName
			)
			this.$nextTick(() => {
				const tabItem = this.listTabs[this.tabIndex]
				if (tabItem.children.length) {
					this.$refs.multipleTable[this.tabIndex].toggleRowExpansion(
						tabItem,
						true
					)
				}
			})
		},
		async tableLoad(tree, treeNode, resolve) {
			variantMaps.set(tree.id, { tree, treeNode, resolve })

			const variantData = await this.getTableItemVariant(tree)
			resolve(variantData)
		},
		refreshTableLoad() {
			try {
				this.listTabs.forEach((item) => {
					const itemObj = variantMaps.get(item.id)
					if (!itemObj) return
					const { tree, treeNode, resolve } = itemObj
					if (tree) {
						this.tableLoad(tree, treeNode, resolve)
					}
				})
			} catch (e) {
				console.log(e)
			}
		},
		getTableItemVariant(tree) {
			const API = Baseurl + 'productController/selectVariantByProductId'
			const paramsData = { id: tree.id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						data.forEach((item) => {
							item.cusSku = item.childSku
							item.cusImgUrl = item.variantEanImageUrl
							const countryVal =
								item.productPriceObject[tree.areaName]
							item.cusPrice = `${countryVal.value} (${countryVal.currency})`
							item.cusSalePrice = `${item.sale || 0} (${
								countryVal.currency
							})`
							item.cusProductPrice = `${countryVal.value}`
							item.cusTitle = `${tree.title ||
								''} ${item.childSku || ''}`
							item.isShow = false
							item.saleTime = [
								item.saleBeginTime || '',
								item.saleEndTime || '',
							]
							item.cusStock = item.stock
							item.cusImages = item.imagesList
						})
						this.listTabs[this.tabIndex].children = data
						resolve(data)
					} else {
						reject('400')
					}
				})
			})
		},
		setTableVal() {
			const tempObj = this.listTabs[this.tabIndex]
			// 产品本身的值
			tempObj.cusProductPrice = this.formData.productPrice
			tempObj.sale = this.formData.sale
			tempObj.saleTime = this.formData.saleTime
			// 产品中变体的值
			tempObj.children.forEach((item) => {
				// debugger
				item.productPriceObject[
					item.countryMark
				].value = this.formData.productPrice
				item.cusProductPrice = this.formData.productPrice
				item.sale = this.formData.sale
				item.saleTime = this.formData.saleTime
			})
			this.$forceUpdate()
		},
		handleTableVal(obj) {
			const resultTableVal = {
				product: {
					id: obj.id,
					productPrice: obj.cusProductPrice,
					sale: obj.sale,
					saleBeginTimeStr: obj.saleTime && obj.saleTime[0],
					saleEndTimeStr: obj.saleTime && obj.saleTime[1],
				},
				variantEans: obj.children.map((item) => {
					item.productPriceObject[item.countryMark].value =
						item.cusProductPrice
					const tempObj = {
						id: item.id,
						sale: item.sale,
						productPrice: '',
						saleBeginTimeStr: item.saleTime && item.saleTime[0],
						saleEndTimeStr: item.saleTime && item.saleTime[1],
					}
					if (item.cusProductPrice) {
						tempObj.productPrice = JSON.stringify(
							item.productPriceObject
						)
					}
					return tempObj
				}),
			}

			// 处理数据：没有值，就不穿此key
			const tempObj = resultTableVal.product
			if (!tempObj.productPrice) {
				delete tempObj.productPrice
			}
			if (
				!tempObj.sale &&
				!tempObj.saleBeginTimeStr &&
				!tempObj.saleEndTimeStr
			) {
				delete tempObj.sale
				delete tempObj.saleBeginTimeStr
				delete tempObj.saleEndTimeStr
			}
			if (
				tempObj.sale ||
				tempObj.saleBeginTimeStr ||
				tempObj.saleEndTimeStr
			) {
				if (
					!(
						tempObj.sale &&
						tempObj.saleBeginTimeStr &&
						tempObj.saleEndTimeStr
					)
				) {
					this.$message.warning('请将促销信息补充完整')
					return
				}
			}
			for (let item of resultTableVal.variantEans) {
				if (!item.productPrice) {
					delete item.productPrice
				}
				if (
					!item.sale &&
					!item.saleBeginTimeStr &&
					!item.saleEndTimeStr
				) {
					delete item.sale
					delete item.saleBeginTimeStr
					delete item.saleEndTimeStr
				}
				if (item.sale || item.saleBeginTimeStr || item.saleEndTimeStr) {
					if (
						!(
							item.sale &&
							item.saleBeginTimeStr &&
							item.saleEndTimeStr
						)
					) {
						this.$message.warning('请将促销信息补充完整')
						return
					}
				}
			}

			// 处理数据：如果只有id，就不传值
			if (Object.keys(tempObj).length === 1 && !!tempObj.id) {
				delete resultTableVal.product
			}
			resultTableVal.variantEans = resultTableVal.variantEans.filter(
				(item) => Object.keys(item).length > 1 && !!item.id
			)
			if (!resultTableVal.variantEans.length) {
				delete resultTableVal.variantEans
			}

			return resultTableVal
		},
		submitUpdate() {
			const API =
				Baseurl + 'productController/batchUpdateProductAndVariant'
			const paramsData = this.handleTableVal(this.listTabs[this.tabIndex])
			if (!Object.keys(paramsData).length) return

			this.loadingUpdate = true
			this.isUpdate = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingUpdate = false
				const { code } = res.data
				if (code === 200) {
					this.$message.success('操作成功')
				}
			})
		},
		handleUpload() {
			const API = Baseurl + 'amaoznFeedUpload/saleProductSubmit'
			const paramsData = {
				marketInfo: JSON.stringify({
					sellerId: this.shopItem.sellerId,
					mwsAuthToken: this.shopItem.mwsAuthToken,
					countryMark: this.shopItem.countryMark,
					marketplaceId: this.shopItem.marketPlaceId,
				}),
				ids: this.listTabs.map((item) => item.id),
				type: 4, // （基本信息1  图片3 价格4 库存5）
			}
			// console.log(JSON.parse(JSON.stringify(paramsData)))
			// return
			this.loadingUpload = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingUpload = false
				const { code, data } = res.data
				if (code === 200) {
					this.$message.success(data)
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.modify-price {
	::v-deep {
		.custom-form {
			margin: 10px 0;

			.el-form-item {
				margin: 0;
			}
		}
	}
}
</style>
